export var DepositStatisticType;
(function (DepositStatisticType) {
    DepositStatisticType[DepositStatisticType["GOLDEN"] = 1] = "GOLDEN";
    DepositStatisticType[DepositStatisticType["THIRD_PARTY"] = 2] = "THIRD_PARTY";
})(DepositStatisticType || (DepositStatisticType = {}));
//# sourceMappingURL=DepositStatisticType.js.map